import React from 'react'
import { useMutation } from '@apollo/react-hooks'
import { Formik, FormikProps } from 'formik'
import { injectIntl, IntlShape } from 'react-intl'
import { useHistory } from 'react-router-dom'

import { Button, Input, HeadingM } from 'cimple-web-common'
import {
  LayoutCRUD,
  LayoutModal
} from 'components/Shared/Layout/LayoutDetail/LayoutDetails'

import { addSupplierValidation } from 'utils/validation/addSupplierValidation'
import { ADD_SUPPLIER } from 'modules/Suppliers/queries'

import * as S from './styled'

import { ROUTES } from 'constants/routes'

type Values = {
  supplierEmail: string
  supplierName: string
}

type SuppliersAddProps = {
  intl: IntlShape
}

const SuppliersAdd: React.FC<SuppliersAddProps> = ({
  intl: { formatMessage: t }
}) => {
  const history = useHistory()
  const [addSupplier, { loading }] = useMutation(ADD_SUPPLIER)

  const handleSubmission = (values: Values) => {
    const { supplierName, supplierEmail } = values

    addSupplier({
      variables: {
        input: { name: supplierName, email: supplierEmail }
      }
    })

    history.push({
      pathname: ROUTES.suppliers
    })
  }

  const initialValues = { supplierEmail: '', supplierName: '' }
  type Values = typeof initialValues

  return (
    <LayoutModal>
      <LayoutCRUD>
        <HeadingM>{t({ id: 'suppliers.addSupplier' })}</HeadingM>
        <Formik
          initialValues={initialValues}
          validate={addSupplierValidation}
          onSubmit={(values: Values) => handleSubmission(values)}
          render={({
            errors,
            isValid,
            handleBlur,
            handleChange,
            handleSubmit,
            touched,
            values
          }: FormikProps<Values>) => {
            return (
              <S.Form onSubmit={handleSubmit}>
                <S.FormInputs>
                  <Input
                    label={t({ id: 'suppliers.supplierName' })}
                    type="text"
                    name="supplierName"
                    placeholder={t({ id: 'suppliers.supplierNamePlaceholder' })}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.supplierName}
                    error={errors.supplierName && touched.supplierName}
                  />
                  <Input
                    label={t({ id: 'suppliers.emailAddress' })}
                    type="email"
                    name="supplierEmail"
                    placeholder={t({ id: 'suppliers.emailAddressPlaceholder' })}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.supplierEmail}
                    error={errors.supplierEmail && touched.supplierEmail}
                  />
                </S.FormInputs>
                <S.FormActions>
                  <Button type="submit" disabled={!isValid} isLoading={loading}>
                    Confirm
                  </Button>
                </S.FormActions>
              </S.Form>
            )
          }}
        />
      </LayoutCRUD>
    </LayoutModal>
  )
}

export default injectIntl(SuppliersAdd)
